import classNames from "classnames";
import { LayoutContext } from "Components/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import { RatingClient, RatingViewModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import LsLoading, { useLsLoading } from "Components/LsLoading";
import { Review } from "./Review";

interface ReviewListProps {
   workspaceId: Guid,
   take?: number,
   className?: string;
   onLoaded?: (reviews: RatingViewModel[]) => void;
}
const ReviewList: React.FC<ReviewListProps> = ({ workspaceId, take, className, onLoaded })  =>
{
   const layoutContext = useContext(LayoutContext);
   const ratingClient = useApiClient(RatingClient);
   const [reviews, setReviews] = useState<RatingViewModel[]>([]);   
   const [wrapperClass, isLoading, setIsLoading] = useLsLoading(true);
   
   const loadReviews = async (abortSignal?: AbortSignal) => {
      setIsLoading(true);
      try {
         const data = await ratingClient.list(workspaceId, take);
         setReviews(data);
         if(onLoaded)
            onLoaded(data);
      }
      catch(ex) {
         if(!abortSignal?.aborted) {
            layoutContext.showError(ex);
         }
      }
      finally {
         if(!abortSignal?.aborted) {
            setIsLoading(false);
         }
      }
   }

   useEffect(() => {
      const abortController = new AbortController();
      loadReviews(abortController.signal);
      return function cancel() {
         abortController.abort();
      }
   }, [workspaceId, take]);

   return (
      <div className={classNames("review-list", wrapperClass, className)}>
         <LsLoading isLoading={isLoading} />
         {reviews.map(r => <Review key={r.id} review={r} />)}
      </div>
   );
}

export default ReviewList;